import gButton from "@/components/g-button/g-button";
import gCard from "@/components/g-card/g-card.vue";
import gDateInput from "@/components/g-date-input/g-date-input";
import gForm from "@/components/g-form/g-form";
import gPdf from "@/components/g-pdf/g-pdf.vue";
import gDataTable from "@/components/g-data-table/g-data-table";
import EmpresaController from "@/shared/controllers/empresa/empresaController";
import ClienteController from "@/shared/controllers/cliente/clienteController";
import RepresentanteController from "@/shared/controllers/representante/representanteController";
import FiltroPedidosAguaAprovacao from "@/shared/view-models/Filtros/FiltroPedidosAguaAprovacao";
import PedidoController from "@/shared/controllers/pedido/PedidoController";
import ProdutoController from "@/shared/controllers/produto/produtoController";
import EVENTS from "@/shared/events/events"
import AccountLoged from "@/shared/mixins/AccountLoged";
import PedidoEmAndamentoPDF from "@/pages/Pedidos/PedidoEmAndamento/components/DetalhesPedidoEmAndamento/PDF/PedidoEmAndamentoPDF.vue";
import { defineComponent } from "vue";

const name = 'PedidoAguardandoAprovacao'

export default defineComponent({
  name,
  
  components: {
    'g-button': gButton,
    'g-card': gCard,
    'g-date-input': gDateInput,
    'g-form': gForm,
    'g-data-table': gDataTable,
    'g-pdf': gPdf,
    PedidoEmAndamentoPDF
  },

  props: { },

  mounted() {
    this.UnidadeArray = this.$store.state.EmpresaArray;
    this.objFiltros.RepresentanteId = this.$store.state.representanteSelecionadoId;
    this.objFiltros.UnidadeId = this.$store.state.empresaSelecionadaId;


    let urlParams = new URLSearchParams(window.location.search)

    if(urlParams.get('FlagDashboard') !== null){
      let myParam = parseInt(urlParams.get('status'))
      this.objFiltros.UnidadeId = this.$store.state.empresaSelecionadaId;
      this.objFiltros.StatusPedidoParcela = myParam;
      this.pt1 = false
      this.GetPedidosAguardandoAprovacaoByFiltro()
    }

    this.GetStatusPedidoParcela()
    this.GetStatus()
    this.TipoPedidoArray = PedidoController.GetInformacaoTipoPedidoEnum().TipoPedidoArray;
    this.RepresentantesArray = this.$store.state.RepresentanteArray;
    this.mitt.on(EVENTS.trocaEmpresaRepresentante, () => {
      this.objFiltros.RepresentanteId = this.$store.state.representanteSelecionadoId;
      this.objFiltros.UnidadeId = this.$store.state.empresaSelecionadaId;
    });
  },

  updated() { },

  data() {
    return {
      pt1: true,
      ProdutoArray: null,
      Colunas : [
        {field: 'pedidoParcela', header: 'Pedido / PC', width: '50px', ordena: true, },
        {field: 'nomeProduto', header: 'Nome do Produto', width: '300px', ordena: true},
        // {field: 'statusPedidoParcelaTexto', header: 'Status', width: '300px', ordena: true},
        {field: 'quantidadePedidoParcela', header: 'Qtd. Solicitada', width: '50px', ordena: true , alinha:'flex-end' , type:'number'},
        {field: 'quantidadeProduzida', header: 'Qtd. Produzida', width: '50px', ordena: true, alinha:'flex-end', type:'number'},
        {field: 'quantidadeExpandida', header: 'Qtd. Expedida', width: '50px', ordena: true, alinha:'flex-end', type:'number'},
        {field: 'saldo', header: 'Saldo', width: '50px', ordena: true, alinha:'flex-end', type:'number'},
        {field: 'dataCarregamentoFormatada', header: 'Dat. Carreg', width: '50px', ordena: true, ordenacao: 'dataCarregamento', alinha:'center'},
        {field: 'dataEntregaFormatada', header: 'Conf. Carreg', width: '50px', ordena: true,ordenacao: 'dataEntrega', alinha:'center'},
      ],
      // ColunasSubGridComponente: [
      //   { field: "componenteTipoTexto", header: "Componentes" },
      // ],
      Filtro: {
          'global': {value: null, matchMode: this.filtros.CONTAINS},
          'codigoExtNum': {value: null, matchMode:this.filtros.CONTAINS},
          'dataInclusaoFormatacao': {value: null, matchMode: this.filtros.CONTAINS},
          'nomeProduto': {value: null, matchMode: this.filtros.CONTAINS},
          'statusPedidoTexto': {value: null, matchMode: this.filtros.CONTAINS},
          'dataPedidoParcelaFormatada': {value: null, matchMode: this.filtros.CONTAINS},
          'numeroParcela': {value: null, matchMode: this.filtros.CONTAINS},
          'quantidadePedidoParcela': {value: null, matchMode: this.filtros.CONTAINS},
          'quantidadeSolicitada': {value: null, matchMode: this.filtros.CONTAINS},
      },

      ClientesArray: [],
      objFiltros: new FiltroPedidosAguaAprovacao(),
      RepresentantesArray:[],
      StatusArray: [],
      StatusParcelaArray: [],
      UnidadeArray: [],
      teste: 2,
      PedidosArray: [],
      TipoPedidoArray: [],
      StatusArrayFront: [],
      componentePedidoAprovacaoArray: [],
      StatusParcela: [],
      pedidoInfosDash: [],
      FlagDashboard: null,
      ClienteAgrupadorAtiva: true,
      renderiza: false,
      executarvisualizacao: 0,
      pedidoId: null
    }
  },

  mixins:[AccountLoged],

  watch: {
    objFiltros() {
      if (this.objFiltros.ClienteId == (undefined || null)) {
        this.ClienteAgrupadorAtiva = true;
      }
    }
  },

  methods: {
    gerarPdf() {
      setTimeout(() => {
        this.executarvisualizacao++
      }, "500");
    },

    abrirPDF(data) {
      this.renderiza = true

      this.pedidoId = data.id
    },

    ativaClienteAgrupador() {
      this.ClienteAgrupadorAtiva = false;
    },
    Grid () {
      this.pt1 = false
      this.GetPedidosAguardandoAprovacaoByFiltro()
      this.getPedidoLog()
    },

    GetStatus(){
      PedidoController.GetStatusPedidoEnum()
      .requisicao.then((Response) => {
            let statusIncluidos = [1,2,3,4,5,8,10,9,13]
            this.StatusArray = Response.data.filter(x => statusIncluidos.includes(x.value))  
            this.StatusArray.unshift({
              text: 'TODOS',
              value: null
            })
          })
          .catch(() => {
          });
      },

      getPedidoLog() {
        this.axios({
          method: "get",
          url:
            process.env.VUE_APP_WEB_API +
            `Pedido/GetPedidoLog/`,
        }).then(() => {
  
        })
      },

      GetStatusPedidoParcela(){
        PedidoController.GetStatusPedidoParcela().requisicao.then((Response) => {
          let statusParcela = [0,1,2]
          this.StatusParcelaArray = Response.data.filter(x => statusParcela.includes(x.value))
        })
        .catch(() => {
        });
      },

    detalhesPedido(data){
      const rotaNovaAbaURL = this.$router.resolve({
        path:`pedido-em-andamento-fluxo/${data.id}/detalhes-pedido-andamento`
      }).href;
      
      window.open(rotaNovaAbaURL, '_blank');
    },

    etiquetaRota(data){
      this.$router.push(`pedido-em-andamento-fluxo/${data.id}/etiqueta-pedido-aguardando-aprovacao`)
    },

    GetPedidosAguardandoAprovacaoByFiltro() {
      this.objFiltros.RepresentanteId = this.$store.state.representanteSelecionadoId
      this.$isLoading(true)
      PedidoController.GetPedidosAguardandoAprovacaoByFiltro(this.objFiltros).requisicao
      .then(response => {
        this.PedidosArray = response.data.data || [];
      })
      .finally(() => this.$isLoading(false))
    },

    limparFiltro(){
      this.objFiltros = new FiltroPedidosAguaAprovacao();
      this.ClientesArray = []
      EmpresaController.getEmpresasAtivas().requisicao
      .then(response => {
        this.UnidadeArray = response.data.data
        this.atualizaEmpresaRepresentante()
      })
      this.mitt.on('trocaEmpresaRepresentante', () => {
        this.atualizaEmpresaRepresentante()
      })

      this.formSearch.RepresentanteId = this.$store.state.representanteSelecionadoId

    },

    atualizaEmpresaRepresentante() {
      this.objFiltros.UnidadeId = this.$store.state.empresaSelecionadaId;
      this.objFiltros.RepresentanteId = this.$store.state.representanteSelecionadoId;
    },

    getEmpresas() {
      EmpresaController.getAllEmpresa()
      .requisicao.then((Response) => {
        this.atualizaEmpresaRepresentante();
        this.EmpresaArray = Response.data.data;
      })
      .catch((Error) => {
        console.error(Error);
      });
    },

    buscarClientes(event){
      window.clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.ClientesArray = ClienteController.GetAllClientesByEmpresaIdEFiltro(this.objFiltros.UnidadeId,event).ClientesArray;
      }, 1000);
    },

    GetPedidoConcluidoByDash(){
      this.pt1 = false
      PedidoController.GetPedidoConcluidoByDash(this.objFiltros.UnidadeId , this.objFiltros.RepresentanteId).requisicao
        .then((Response) => {
          this.PedidosArray = Response.data.data;
        }, 1100)
        .catch(() => {
        },
      )
    },

    getProduto(pesquisa) {
      window.clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        ProdutoController.GetProdutoDropDownByPesquisaRepresentanteEmpresa(pesquisa, this.$store.state.representanteSelecionadoId, this.objFiltros.UnidadeId).requisicao
        .then((res) => {
          this.ProdutoArray = res.data.data
        })
        .catch(() => {
        })
      }, 1000);
    },

    getCodigo(produtoId){
      ProdutoController.GetCodigoByProdutoId(produtoId).requisicao
        .then((res) => {
          this.objFiltros.CodigoProduto = res.data.message
        })
        .catch(() => {
        })
    },

    buscarRepresentante(event){
      window.clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.RepresentantesArray = RepresentanteController.getRepresentanteByPesquisaEUsuario(event).RepresentanteArray;
      }, 1000);
    },
  }

});